import axios from "axios";

/**
 * Upload a file directly to S3 using a presigned PUT URL.
 *
 * This must NOT use apiClient — apiClient injects:
 *   1. baseURL pointing at Flask, which would corrupt the S3 URL
 *   2. Authorization: Bearer <token>, which breaks the presigned signature
 *      (S3 verifies the signed headers match exactly — extra headers = 403)
 *
 * @param {string} uploadUrl  Presigned S3 PUT URL from /api/upload/init
 * @param {File}   file       Browser File object to upload
 * @returns {Promise<import("axios").AxiosResponse>}
 */
export const uploadToS3 = (uploadUrl, file, onProgress) =>
  axios.put(uploadUrl, file, {
    headers: {
      "Content-Type": file.type || "application/octet-stream",
      "x-amz-server-side-encryption": "AES256",
    },
    ...(onProgress && {
      onUploadProgress: (e) => {
        if (e.total) onProgress(Math.round((e.loaded / e.total) * 100));
      },
    }),
  });
